import { render } from "./ActivityBadgeLayout.vue?vue&type=template&id=fc55e7b6&scoped=true"
import script from "./ActivityBadgeLayout.vue?vue&type=script&lang=js"
export * from "./ActivityBadgeLayout.vue?vue&type=script&lang=js"

import "./ActivityBadgeLayout.vue?vue&type=style&index=0&id=fc55e7b6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fc55e7b6"

export default script